
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const ClockIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M51.5 25.5C51.5 23.567 49.933 22 48 22C46.067 22 44.5 23.567 44.5 25.5V48C44.5 48.9283 44.8687 49.8185 45.5251 50.4749L56.0251 60.9749C57.392 62.3417 59.608 62.3417 60.9749 60.9749C62.3417 59.608 62.3417 57.392 60.9749 56.0251L51.5 46.5503V25.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8ZM15 48C15 29.7746 29.7746 15 48 15C66.2254 15 81 29.7746 81 48C81 66.2254 66.2254 81 48 81C29.7746 81 15 66.2254 15 48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M51.5 25.5C51.5 23.567 49.933 22 48 22C46.067 22 44.5 23.567 44.5 25.5V48C44.5 48.9283 44.8687 49.8185 45.5251 50.4749L56.0251 60.9749C57.392 62.3417 59.608 62.3417 60.9749 60.9749C62.3417 59.608 62.3417 57.392 60.9749 56.0251L51.5 46.5503V25.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8ZM15 48C15 29.7746 29.7746 15 48 15C66.2254 15 81 29.7746 81 48C81 66.2254 66.2254 81 48 81C29.7746 81 15 66.2254 15 48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
